import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LogoCSS from '../logo-css';

import { useEffect, useState } from 'react';
import { getPendingOrdersCount } from '../services/api';

const Navbar = ({ isAuthenticated, user, logout }) => {
  const navigate = useNavigate();
  const [pendingOrdersCount, setPendingOrdersCount] = useState(0);

  useEffect(() => {
    if (user && (user.role === 'admin' || user.role === 'union')) {
      fetchPending();
    }
    // eslint-disable-next-line
  }, [user]);

  const fetchPending = async () => {
    try {
      const res = await getPendingOrdersCount();
      setPendingOrdersCount(res.data.pending_count);
    } catch {}
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <LogoCSS />
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          {isAuthenticated ? (
            <>
              <ul className="navbar-nav me-auto">
                <li className="nav-item">
                  <Link className="nav-link" to="/">首页</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/activities">活动列表</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/my-activities">我的活动</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/my-points">我的积分</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/shop">积分商城</Link>
                </li>
                {(user.role === 'admin' || user.role === 'union') && (
                  <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      管理菜单
                    </a>
                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                      {user.role === 'admin' && (
                        <>
                          <li><Link className="dropdown-item" to="/admin">控制面板</Link></li>
                          <li><Link className="dropdown-item" to="/admin/system-config">系统配置</Link></li>
                          <li><Link className="dropdown-item" to="/admin/points">积分管理</Link></li>
                          
                          <li><Link className="dropdown-item" to="/admin/points-logs">积分操作日志</Link></li>
                          <li><hr className="dropdown-divider" /></li>
                        </>
                      )}
                      <li><Link className="dropdown-item" to="/admin/users">用户管理</Link></li>
                      <li><Link className="dropdown-item" to="/admin/activities">活动管理</Link></li>
                      <li><Link className="dropdown-item" to="/admin/user-activities">报名管理</Link></li>
                      <li><Link className="dropdown-item" to="/admin/shop">商城管理</Link></li>         
<li>
  <Link className="dropdown-item position-relative d-flex align-items-center" to="/admin/shop-orders">
    订单管理
    {pendingOrdersCount > 0 && (
      <span id="nav-pending-badge" className="badge rounded-pill bg-danger ms-2" style={{fontSize: '0.7em', position:'static'}}>{pendingOrdersCount}</span>
    )}
  </Link>
</li>
                    </ul>
                  </li>
                )}
              </ul>
              <div className="d-flex">
                <span className="navbar-text me-3">
                  欢迎, {user.nickname || user.username} (
                  {user.role === 'admin' ? '管理员' : 
                   user.role === 'union' ? '工会委员' : '用户'})
                </span>
                <button className="btn btn-outline-light" onClick={handleLogout}>退出</button>
              </div>
            </>
          ) : (
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/login">登录</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/register">注册</Link>
              </li>
            </ul>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
